import LinkCarousel from 'components/Content/NavigationCarousel/LinkCarousel/LinkCarousel';

export default LinkCarousel;
